import React from 'react';

const Links = () => (
	<div className="container main">
		<h2>관련 웹사이트</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<div className="media">
					<div className="media-left">
						<a href="https://aseanconsumer.org/product-alert" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/Asean.png')} alt="ASEAN"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">ASEAN</h4>
						<a href="https://aseanconsumer.org/product-alert" target="_blank">www.aseanconsumer.org/product-alert</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://www.productsafety.gov.au/recalls" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/Australia.png')} alt="호주"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">호주</h4>
						<a href="https://www.productsafety.gov.au/recalls" target="_blank">www.productsafety.gov.au/recalls</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://recalls-rappels.canada.ca/en" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/Canada.png')} alt="캐나다"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">캐나다</h4>
						<a href="https://recalls-rappels.canada.ca/en" target="_blank">recalls-rappels.canada.ca/en</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://www.consumo.go.cr/tramites_servicios/retiros_mercado.aspx" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/Costa-Rica.png')} alt="코스타리카"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">코스타리카</h4>
						<a href="https://www.consumo.go.cr/tramites_servicios/retiros_mercado.aspx" target="_blank">www.consumo.go.cr/tramites_servicios/retiros_mercado.aspx</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://ec.europa.eu/safety-gate" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/European-Union.png')} alt="European Commission"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">유럽연합</h4>
						<a href="https://ec.europa.eu/safety-gate" target="_blank">ec.europa.eu/safety-gate</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="http://www.dgccrf.bercy.gouv.fr" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/France.png')} alt="프랑스"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">프랑스</h4>
						<a href="http://www.dgccrf.bercy.gouv.fr" target="_blank">www.dgccrf.bercy.gouv.fr</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://go.gov.il/pcps" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/Israel.png')} alt="이스라엘"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">이스라엘</h4>
						<a href="https://go.gov.il/pcps" target="_blank">go.gov.il/pcps</a>
					</div>
				</div>
			</div>
			<div className="col-sm-6">
				<div className="media">
					<div className="media-left">
						<a href="https://www.recall.caa.go.jp" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/Japan.png')} alt="일본"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">일본</h4>
						<a href="https://www.recall.caa.go.jp" target="_blank">www.recall.caa.go.jp</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="http://www.alertas.gob.mx" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/Mexico.png')} alt="멕시코"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">멕시코</h4>
						<a href="http://www.alertas.gob.mx" target="_blank">www.alertas.gob.mx</a>
						{' | '}
						<a href="https://www.gob.mx/profeco/articulos/alertas-al-consumidor-35310" target="_blank">www.gob.mx/profeco/articulos/alertas-al-consumidor-35310</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://www.productsafety.govt.nz/recalls" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/New-Zealand.png')} alt="뉴질랜드"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">뉴질랜드</h4>
						<a href="https://www.productsafety.govt.nz/recalls" target="_blank">www.productsafety.govt.nz/recalls</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://www.consumer.go.kr" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/South-Korea.png')} alt="한국"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">대한민국</h4>
						<a href="https://www.consumer.go.kr" target="_blank">www.consumer.go.kr</a>
						{' | '}
						<a href="http://www.safetykorea.kr" target="_blank">www.safetykorea.kr</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://eservices.esma.gov.ae/app/Manaa/recentRecalled" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/United-Arab-Emirates.png')} alt="아랍에미리트연합국"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">아랍에미리트</h4>
						<a href="https://eservices.esma.gov.ae/app/Manaa/recentRecalled" target="_blank">eservices.esma.gov.ae/app/Manaa/recentRecalled</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://www.gov.uk/guidance/product-recalls-and-alerts" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/United-Kingdom.png')} alt="영국"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">영국</h4>
						<a href="https://www.gov.uk/guidance/product-recalls-and-alerts" target="_blank">www.gov.uk/guidance/product-recalls-and-alerts</a>
					</div>
				</div>
				<div className="media">
					<div className="media-left">
						<a href="https://www.saferproducts.gov" target="_blank">
							<img className="media-object" src={require('../../../assets/images/flags/United-States.png')} alt="미국"/>
						</a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">미국</h4>
						<a href="https://www.saferproducts.gov" target="_blank">www.saferproducts.gov</a>
					</div>
				</div>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4/>
				<p/>
			</div>
			<div className="col-sm-6">
				<h4/>
				<p/>
			</div>
		</div>
	</div>
);

export default Links;



// WEBPACK FOOTER //
// ./src/views/static/ko/links.js